import { useSelector } from "react-redux";

const LoadWizardStepper = ({ steps, step, setStep }) => {
  const {load} = useSelector(state=>state.Load)

  return (
    <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm px-4 py-4 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {steps.map((s, index) => {
          const isActive = s.id === step;
          const isCompleted = s.isCompleted

          return (
            <div key={s.id} className="flex items-start gap-3 md:flex-1">
              {/* círculo */}
              <div
                onClick={()=>[s.isBloked ? console.log('block'):setStep(s.id)]}
                title={s.isBloked ? 'Please complete Step 1: Load & Equipment first.':''}
                className={`
                  flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold
                  ${s.isBloked ? 'cursor-not-allowed':'cursor-pointer'}
                  border
                  ${isActive
                    ? "bg-cs-primary text-white border-cs-primary"
                    : isCompleted
                      ? "bg-cs-primary-soft text-cs-primary border-cs-primary"
                      : "bg-cs-bg text-cs-muted border-cs-border"}
                `}
              >
                {isCompleted ? (
                  <span className="material-symbols-outlined text-sm">
                    check
                  </span>
                ) : (
                  s.id
                )}
              </div>

              {/* texto */}
              <div className="space-y-0.5">
                <p
                  className={`
                    text-sm font-medium
                    ${isActive ? "text-cs-dark" : "text-cs-muted"}
                  `}
                >
                  {s.label}
                </p>
                <p className="text-xs text-cs-muted">{s.desc}</p>
              </div>

              {/* línea conectora */}
              {index < steps.length - 1 && (
                <div className="hidden md:block flex-1 h-px bg-cs-border mt-4 ml-3" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LoadWizardStepper;
